<template>
  <fullscreen
    v-model="fullscreen"
    :class="{ white: fullscreen }"
    style="overflow: auto; height: 100%"
    class="d-flex flex-column"
  >
    <div class="pa-2">
      <div v-if="!fullscreen" class="mb-1">
        <span class="ml-1 font-weight-medium">การใช้งาน Device</span>
      </div>
      <v-card outlined class="pa-2">
        <div class="d-flex justify-space-between align-center">
          <div>
            <v-btn icon @click="setFullscreen">
              <v-icon size="36" v-if="!fullscreen">mdi-fullscreen</v-icon>
              <v-icon size="36" v-else>mdi-fullscreen-exit</v-icon>
            </v-btn>
            <v-btn
              icon
              :color="
                currentViewComponent === 'DeviceUseTableView' ? 'primary' : ''
              "
              @click="setCurrentViewComponent('DeviceUseTableView')"
            >
              <v-icon>mdi-page-layout-header-footer</v-icon>
            </v-btn>
            <v-btn
              icon
              :color="
                currentViewComponent === 'DeviceUseTopView' ? 'primary' : ''
              "
              @click="setCurrentViewComponent('DeviceUseTopView')"
            >
              <v-icon>mdi-page-layout-header</v-icon>
            </v-btn>
            <v-btn
              icon
              :color="
                currentViewComponent === 'DeviceUseLeftView' ? 'primary' : ''
              "
              @click="setCurrentViewComponent('DeviceUseLeftView')"
            >
              <v-icon> mdi-page-layout-sidebar-left </v-icon>
            </v-btn>
          </div>
          <div v-if="!fullscreen">
            <v-dialog
              v-model="dialogHardwares"
              scrollable
              max-width="520px"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-filter</v-icon>
                  เลือกดูเฉพาะ Device
                  <v-avatar class="ml-2" color="primary" size="24">
                    <span class="white--text subtitle-2">
                      {{ filterDeviceCount }}
                    </span>
                  </v-avatar>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <v-text-field
                    v-model="searchHardwares"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    style="width: 100%"
                  ></v-text-field>
                  <v-btn
                    class="mt-2"
                    :disabled="!selectedHardwares.length"
                    outlined
                    small
                    color="primary"
                    @click="handleDeselectAll"
                  >
                    ยกเลิกการเลือกทั้งหมด
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text
                  v-if="
                    uiCtrl &&
                    uiCtrl.isEnable(
                      'checkbox:::monitor:transaction:employee:mobile'
                    )
                  "
                >
                  <v-checkbox
                    v-model="filterMobile"
                    class="mt-3"
                    hide-details
                    label="Mobile"
                  ></v-checkbox>
                </v-card-text>
                <v-divider
                  v-if="
                    uiCtrl &&
                    uiCtrl.isEnable(
                      'checkbox:::monitor:transaction:employee:mobile'
                    )
                  "
                ></v-divider>
                <v-card-text
                  v-if="
                    uiCtrl &&
                    uiCtrl.isEnable('row:::monitor:transaction:employee:get')
                  "
                  style="height: 520px"
                >
                  <v-checkbox
                    v-model="selectedHardwares"
                    v-for="hardware in filterHardwares"
                    :key="hardware.hardware_uuid"
                    :label="hardware.text"
                    :value="hardware.hardware_uuid"
                    hide-details
                  ></v-checkbox>
                </v-card-text>
                <v-divider
                  v-if="
                    uiCtrl &&
                    uiCtrl.isEnable('row:::monitor:transaction:employee:get')
                  "
                ></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="handleFilterHardwares"
                  >
                    ตกลง
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </v-card>
    </div>
    <div class="flex-grow-1">
      <component
        :is="currentViewComponent"
        :fullscreen="fullscreen"
        :transactions="transactions"
      ></component>
    </div>
  </fullscreen>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

import DeviceUseLeftView from '@/views/monitoring/DeviceUseLeftView.vue'
import DeviceUseTableView from '@/views/monitoring/DeviceUseTableView.vue'
import DeviceUseTopView from '@/views/monitoring/DeviceUseTopView.vue'

import { WEBSOCKET_CONFIG } from '@/constants/websocket'

export default {
  components: {
    DeviceUseTableView,
    DeviceUseLeftView,
    DeviceUseTopView,
  },
  data() {
    return {
      filterMobile: false,
      transactionsLimit: WEBSOCKET_CONFIG.TRANSACTION_LIMIT,
      websocketReconnectCount: 0,
      searchHardwares: '',
      selectedHardwares: [],
      dialogHardwares: false,
      transactions: [],
      websocket: null,
      currentViewComponent: 'DeviceUseTableView',
      fullscreen: false,
    }
  },
  computed: {
    filterDeviceCount() {
      let count = 0
      count += this.filterMobile ? 1 : 0
      count += this.selectedHardwares.length

      return count
    },
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    user() {
      return this.$store.state.authentication.user
    },
    hardwares() {
      return this.$store.state.hardware.hardwares
        .map((hardware) => ({
          hardware_uuid: hardware.hardware_uuid,
          hardware_code: hardware.hardware_code,
          text: hardware.title_th
            ? `${hardware.hardware_code} - ${hardware.title_th}`
            : hardware.hardware_code,
        }))
        .sort((a, b) => a.hardware_code.localeCompare(b.hardware_code))
    },
    filterHardwares() {
      let items = this.hardwares

      if (this.searchHardwares) {
        items = items.filter((item) => {
          return item.text
            .toLowerCase()
            .includes(this.searchHardwares.toLowerCase())
        })
      }

      return items
    },
  },
  watch: {
    uiCtrl(value) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('menu:::transaction_employee')) {
        this.$router.push({ name: 'Home' })
      } else if (value) {
        this.loadData()
      }
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การใช้งาน Device',
        disabled: true,
      },
    ])

    if (this.user) {
      const userConfig = localStorage.getItem(this.user.uuid)
      const menuDeviceUse = userConfig
        ? JSON.parse(userConfig)['menu-device-use']
        : null
      if (menuDeviceUse) {
        this.selectedHardwares = menuDeviceUse.devices || []
        this.filterMobile = menuDeviceUse.mobile || false
      }
    }

    this.getTransactions({
      company_uuid: this.$store.state.authentication.company.company_uuid,
      body: {
        limit: 5,
        is_transaction_mobile: this.filterMobile,
        hardware_uuids: [...this.selectedHardwares],
      },
    }).then((response) => {
      this.transactions = [...response]
    })

    if (this.uiCtrl && this.uiCtrl.isEnable('menu:::transaction_employee')) {
      this.loadData()
    }
  },
  methods: {
    ...mapActions({
      getTransactions: 'transaction/getTransactions',
      fetchHardwares: 'hardware/fetchHardwares',
    }),
    loadData() {
      if (
        this.uiCtrl &&
        this.uiCtrl.isEnable('row:::monitor:transaction:employee:get')
      ) {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.commit('SET_LOADING', true)

        const payload = {
          params: {
            dpc: 'monitor-transaction-employee-to-list-hardware',
            company_uuid,
          },
        }
        this.fetchHardwares(payload)
          .catch((error) => {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
          .finally(() => {
            this.$store.commit('SET_LOADING', false)
          })
      }

      localStorage.removeItem('logs')
      this.connectWebsocket()
    },
    handleDeselectAll() {
      this.selectedHardwares = []
    },
    connectWebsocket() {
      if (process.env.NODE_ENV === 'development') {
        console.log(
          '[WebSocket]',
          `call function connect websocket :: ${new Date()}`
        )
      }

      const { company_uuid } = this.$store.state.authentication.company

      if (this.websocket) {
        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `clear old websocket :: ${new Date()}`)
        }

        this.websocket.close()
      }

      if (process.env.NODE_ENV === 'development') {
        console.log(
          '[WebSocket]',
          `Starting Connection to WebSocket Server :: ${new Date()}`
        )
      }

      this.websocket = new WebSocket(
        process.env.VUE_APP_API_WEB_SOCKET_ENDPOINT
      )

      this.websocket.onopen = () => {
        if (process.env.NODE_ENV === 'development') {
          console.log(
            '[WebSocket]',
            `Successfully connected to the echo WebSocket Server :: ${new Date()}`
          )
        }

        const transactionSourceCode = []
        if (this.filterMobile) {
          transactionSourceCode.push('mastertime_mobile_app')
        }

        // SEND MESSAGE TOPIC
        this.sendMessage({
          scope: `${process.env.VUE_APP_REALTIME_ENV_SCOPE}:${company_uuid}`,
          topic: 'transaction',
          args: {
            transaction_source_code: transactionSourceCode,
            hardware_uuid: [...this.selectedHardwares],
            employee_uuid: [],
          },
        })
      }

      this.websocket.onmessage = (event) => {
        try {
          const data = JSON.parse(event?.data)
          const payload = JSON.parse(data?.payload)

          const hardwaresUuid = this.hardwares.map((h) => h.hardware_uuid)

          const isMobileTransaction =
            payload.transaction_source?.transaction_source_code ===
            'mastertime_mobile_app'

          const isHardwareTransaction =
            payload.hardware &&
            hardwaresUuid.includes(payload.hardware.hardware_uuid)

          const hasMobilePermission = this.uiCtrl?.isEnable(
            'checkbox:::monitor:transaction:employee:mobile'
          )

          // Check if should display this transaction
          const shouldDisplay =
            (isMobileTransaction && this.filterMobile && hasMobilePermission) ||
            (isHardwareTransaction &&
              this.selectedHardwares.includes(
                payload.hardware.hardware_uuid
              )) ||
            (!this.filterMobile && this.selectedHardwares.length === 0) // Show all if no filter

          if (shouldDisplay) {
            this.setMonitorTransaction(payload)
          }
        } catch (error) {
          console.error('[WebSocket] Failed to parse message:', error)

          if (process.env.NODE_ENV === 'development') {
            console.log('[WebSocket] Raw data:', event.data)
          }
        }
      }

      this.websocket.onclose = (event) => {
        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `${event} :: ${new Date()}`)
        }

        if (event.wasClean) {
          if (process.env.NODE_ENV === 'development') {
            console.log(
              '[WebSocket]',
              `[close] Connection closed cleanly, code=${event.code} reason=${
                event.reason
              } :: ${new Date()}`
            )
          }
        } else {
          // e.g. server process killed or network down
          // event.code is usually 1006 in this case
          if (process.env.NODE_ENV === 'development') {
            console.log(
              '[WebSocket]',
              `${
                window?.navigator?.onLine ? 'online' : 'offline'
              } :: ${new Date()}`
            )
            console.log(
              '[WebSocket]',
              `[close] Connection died :: ${new Date()}`
            )
          }

          this.handleReconnectWebsocket(this)
        }
      }

      this.websocket.onerror = (error) => {
        console.error('[WebSocket Error]', error)

        // Show error to user
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          color: 'error',
          timeout: -1,
          message: 'เกิดข้อผิดพลาดในการเชื่อมต่อ WebSocket',
        })

        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `[error] ${error} :: ${new Date()}`)
        }
      }
    },
    setMonitorTransaction(payload) {
      if (this.transactions.length === this.transactionsLimit) {
        this.transactions.pop()
        this.transactions.unshift(payload)
      } else {
        this.transactions.unshift(payload)
      }
    },
    handleReconnectWebsocket: _.debounce((self) => {
      if (process.env.NODE_ENV === 'development') {
        console.log(
          '[WebSocket]',
          `call handle reconnect websocket :: ${new Date()}`
        )
      }

      self.websocketReconnectCount += 1

      if (
        self.websocketReconnectCount <= WEBSOCKET_CONFIG.RECONNECT_MAX_ATTEMPTS
      ) {
        if (process.env.NODE_ENV === 'development') {
          console.log(
            '[WebSocket]',
            `reconnect websocket : ${
              self.websocketReconnectCount
            } :: ${new Date()}`
          )
        }

        self.connectWebsocket()
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `refresh page :: ${new Date()}`)
        }

        // refresh page
        self.$router.go(0)
      }
    }, WEBSOCKET_CONFIG.RECONNECT_DELAY),
    handleFilterHardwares() {
      if (this.user) {
        const userConfig = localStorage.getItem(this.user.uuid)
        const menuDownloadTransaction = userConfig
          ? JSON.parse(userConfig)['menu-download-transaction']
          : null
        const menuEmployee = userConfig
          ? JSON.parse(userConfig)['menu-employee']
          : null

        const config = {
          ['menu-download-transaction']: menuDownloadTransaction
            ? menuDownloadTransaction
            : undefined,
          ['menu-employee']: menuEmployee ? menuEmployee : undefined,
          ['menu-device-use']: {
            mobile: this.filterMobile,
            devices: this.selectedHardwares,
          },
        }

        localStorage.setItem(this.user.uuid, JSON.stringify(config))
      }

      this.dialogHardwares = false
      this.connectWebsocket()
    },
    sendMessage(message) {
      if (this.websocket) {
        this.websocket.send(JSON.stringify(message))
      }
    },
    setFullscreen() {
      this.fullscreen = !this.fullscreen
    },
    setCurrentViewComponent(view) {
      this.currentViewComponent = view
    },
  },
  beforeDestroy() {
    // Clear WebSocket
    if (this.websocket) {
      this.websocket.onopen = null
      this.websocket.onmessage = null
      this.websocket.onclose = null
      this.websocket.onerror = null
      this.websocket.close()
      this.websocket = null
    }

    // Cancel debounced function
    if (this.debouncedReconnect?.cancel) {
      this.debouncedReconnect.cancel()
    }

    // Clear reconnect count
    this.websocketReconnectCount = 0
  },
}
</script>
